/* global google */
import lookup from './data/lookup.json';

class GPMapper {
  constructor() {
    this.$maps = $('.gp-mapper');
    this.mapElements = []; // $('#gp-mapper-map');
    this.data = []; // window.GPMapperLocations + unique id
    this.map = [];
    this.markers = [];

    this.geocoder = new google.maps.Geocoder();
    this.regex = new RegExp('[0-9]{4}[\s]{0,1}[a-zA-Z]{2}'); // eslint-disable-line no-useless-escape
  }

  init() {
    if (!this.$maps.length) {
      return;
    }

    this.$maps.each((i, map) => {
      const id = map.dataset.id; // eslint-disable-line prefer-destructuring
      this.data[id] = window[`GPMapperData${id}`];

      const mapElement = $(map).find(`#gp-mapper-map-${id}`)[0];
      this.createMap(id, mapElement, this.data[id].mapOptions);

      this.markers[id] = [];
      this.data[id].locations.forEach((location) => {
        this.addMarker(location, id);
      });

      this.BindEvents(map, id);
    });
  }

  BindEvents(map, id) {
    const $input = $(map).find('input[type=text]');
    const $submit = $(map).find('button.submit');

    $submit.bind('click', () => {
      const target = $input[0];

      if (!this.regex.test(target.value)) {
        target.classList.add('is-invalid');
        return;
      }
      target.classList.remove('is-invalid');

      if (this.data[id].mapOptions.postalCodeLookup) {
        const closetsMarker = this.lookup(target.value, id);
        if (closetsMarker === undefined) {
          target.classList.add('is-invalid');
          return;
        }
        this.infoWindowOpen(id, closetsMarker);
      } else {
        this.geocoder.geocode({
          address: `${target.value} The Netherlands`,
        }, (results, status) => {
          if (status !== 'OK') {
            target.classList.add('is-invalid');
            return;
          }

          const closetsMarker = this.closest(results[0].geometry.location, id);
          this.infoWindowOpen(id, closetsMarker);
        });
      }
    });

    $input.on('keyup', (e) => {
      if (e.keyCode === 13) {
        $submit.trigger('click');
      }
    });
  }

  lookup(postalCode, id) {
    const postalNumber = parseInt(postalCode.substring(0, 4), 10);

    const item = lookup.find(i => i['Postal code'] === postalNumber);

    if (item === undefined) {
      return undefined;
    }

    return this.markers[id].find(i => i.title === item.Territory);
  }

  closest(point, id) {
    const distances = [];
    let closest = -1;

    this.markers[id].forEach((element, i) => {
      distances[i] = google.maps.geometry.spherical.computeDistanceBetween(element.position, point);

      if (distances[i] < distances[closest] || closest === -1) {
        closest = i;
      }
    });

    return this.markers[id][closest];
  }

  addMarker(location, id) {
    this.geocoder.geocode({
      address: location.location_address,
    }, (results, status) => {
      if (status !== 'OK') {
        return;
      }

      const marker = new google.maps.Marker({
        title: location.location_lookup_id,
        position: results[0].geometry.location,
        map: this.map[id],
        icon: '//maps.google.com/mapfiles/ms/icons/red-dot.png',
      });

      marker.attachedInfoWindow = this.createInfoWindow(location);

      this.markers[id].push(marker);

      google.maps.event.addListener(marker, 'click', (() => {
        this.infoWindowOpen(id, marker);
      }));
    });
  }

  infoWindowOpen(id, marker) {
    if (window.innerWidth >= 1200) {
      this.map[id].setZoom(12);
    }
    this.closeInfoWindows(id);
    this.map[id].setCenter(marker.position);
    marker.attachedInfoWindow.open(this.map[id], marker);
  }

  createMap(id, element, mapOptions) {
    this.map[id] = new google.maps.Map(element, {
      center: new google.maps.LatLng(mapOptions.Lat || 52.32863, mapOptions.Lng || 5.29541),
      zoom: mapOptions.zoom || 7,
    });
  }

  createInfoWindow(location) { // eslint-disable-line class-methods-use-this
    let content = `<strong>${location.location_title}</strong><br>
    ${location.location_address} <br><br>
    ${location.location_description}`;

    if (typeof location.location_tel !== 'undefined'
      && typeof location.location_tel_nice !== 'undefined') {
      content += `<br><br>Bel: <a href="tel:+${location.location_tel}">${location.location_tel_nice}</a>`;
    }

    content += `<br><a target="_blank" href="https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(this.strip(location.location_address)).replace('%20', '+')}">Routebeschrijving</a>`;

    const infoWindow = new google.maps.InfoWindow({
      content,
    });

    return infoWindow;
  }

  closeInfoWindows(id) {
    this.markers[id].forEach((marker) => {
      marker.attachedInfoWindow.close(this.map[id], marker);
    });
  }

  strip(html) { // eslint-disable-line class-methods-use-this
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || '';
  }
}

$(document).ready(() => {
  const gpm = new GPMapper();
  gpm.init();
});
